import colorVars from "@/assets/styles/colorVars"
import Heading from "@/components/heading"
import { BaseImage } from "@/components/image/base-image"
import { PillTag, PillTagProps } from "@/components/pill-tag"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

export interface IBenefit {
  description?: string
  image?: Queries.WpMediaItem
  pill?: PillTagProps
  title?: string
}

export interface BenefitProps {
  className?: string
  data?: IBenefit
  leftImg?: boolean
}

const Wrapper = styled.div<BenefitProps>`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin: 0 auto;

  ${up("md")} {
    flex-direction: ${(props) => (props.leftImg ? "row-reverse" : "row")};
  }

  ${up("lg")} {
    max-width: calc(1120px + 32px);
  }
`

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px 0;
  align-items: flex-start;
  max-width: 453px;
  margin-bottom: 16px;
`

const StyledPillTag = styled(PillTag)`
  height: 32px;
  padding: 0 13px;
  margin-top: 1px;
`

export const StyledHeading = styled(Heading)`
  margin: -8px 0 -7px;
  font-size: 23px;

  ${up("md")} {
    margin: 0 0 -14px;
    font-size: 32px;
    letter-spacing: -0.6px;
  }
`

export const Description = styled.p`
  margin: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  color: ${colorVars.text.gray};
  letter-spacing: 0;

  ${up("md")} {
    position: relative;
    top: 31px;
    margin: -16px 0 0;
    line-height: 26px;
    letter-spacing: -0.1px;
  }
`

export const ImageWrapper = styled.div``

const BenefitImg = styled(BaseImage)`
  max-width: 560px;
`

export const Benefit: FC<BenefitProps> = (props) => {
  const { className, data, leftImg } = props

  if (!data) return null

  return (
    <Wrapper
      className={className && className !== "" ? className : ""}
      leftImg={leftImg ?? false}>
      <InfoWrapper>
        <StyledPillTag {...data.pill} />
        <StyledHeading preLine size="h3" title={data.title} />
        <Description>{data.description}</Description>
      </InfoWrapper>
      <ImageWrapper>
        <BenefitImg image={data.image} />
      </ImageWrapper>
    </Wrapper>
  )
}
